module.exports = __webpack_public_path__ + "src/assets/rs.9381da88.png";